/* Layout-only chrome that Astryx components can't express on their own:
   the active/indent modifiers, the button reset for the label hit-target,
   the draggable-row cursor treatment, and the hover/focus-reveal for the
   delete control. Colors/spacing come from Astryx tokens; text itself
   renders via `Text`, not this file. */

.row {
  border-radius: var(--radius-inner);
  padding-inline-end: var(--spacing-1);
}

.indented {
  padding-inline-start: var(--spacing-5);
}

.active {
  background: var(--color-background-muted);
}

/* Applied when `dragHandleProps` is present (i.e. not the read-only rail) —
   the whole row is the drag surface, so it reads as draggable on hover
   everywhere in the row, including over the label text (see `.draggable
   .label` below, which overrides the label's own `cursor: pointer` so the
   whole row unambiguously reads as grabbable — its click-to-scroll behavior
   is unaffected, only the cursor changes). */
.draggable:hover {
  background: var(--color-background-muted);
  cursor: grab;
}

.draggable:active {
  cursor: grabbing;
}

/* Purely a visual drag indicator — never interactive itself (a plain
   `Icon`, not an `IconButton`; no hover/color change of its own).
   `pointer-events: none` guarantees it can never intercept a hover or
   click meant for the row (the actual drag surface, styled via
   `.draggable` above) or whatever's beneath it. Always visible (no
   opacity/reveal of its own) — unlike `.delete` below, which stays
   hover-revealed. */
.grip {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  pointer-events: none;
}

.label {
  flex: 1;
  min-width: 0;
  display: block;
  border: none;
  background: none;
  margin: 0;
  padding: var(--spacing-2) var(--spacing-1);
  text-align: start;
  cursor: pointer;
  border-radius: var(--radius-inner);
}

.label:hover,
.label:focus-visible {
  background: var(--color-background-muted);
}

/* Within a draggable row, the label reads as part of the drag surface too —
   overrides the label's own `cursor: pointer` above with the row's
   grab/grabbing cursor (two classes vs. `.label`'s one, so this wins on
   specificity regardless of source order). Click-to-scroll still fires
   normally; only the cursor changes. Read-only rows have no `.draggable`
   class, so their labels keep the plain pointer cursor unchanged. */
.draggable .label {
  cursor: grab;
}

.draggable .label:active {
  cursor: grabbing;
}

.delete {
  flex-shrink: 0;
  opacity: 0;
  transition: opacity var(--duration-fast) var(--easing-default);
}

.row:hover .delete,
.row:focus-within .delete {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .delete {
    transition: none;
  }
}
